/**
 * Quote Response Toast Notifications
 *
 * Provides type-safe toast utilities for quote response operations
 * Handles success, error, and loading states with user-friendly messages
 */

import { toast } from "sonner";
import { QuoteErrorType, QuoteErrorDetail } from "./error-types";

export const quoteToast = {
  /**
   * Show success toast for file upload
   */
  uploadSuccess: (fileCount: number) => {
    toast.success("파일 업로드 완료", {
      description: `${fileCount}개의 파일이 업로드되었습니다.`,
    });
  },

  /**
   * Show success toast for quote submission
   */
  submissionSuccess: () => {
    toast.success("견적이 성공적으로 제출되었습니다!", {
      description: "곧 창이 닫힙니다.",
      duration: 2000,
    });
  },

  /**
   * Show error toast with type-specific and contextual messages
   *
   * Priority:
   * 1. detail.action (from error-classifier, highest priority)
   * 2. Type-specific fallback descriptions
   * 3. Default fallback if type is UNKNOWN
   */
  error: (detail: QuoteErrorDetail) => {
    // Type-specific fallback descriptions with more contextual guidance
    const descriptions: Record<QuoteErrorType, string> = {
      [QuoteErrorType.UPLOAD_FAILED]:
        "파일 크기(10MB 이하)와 지원 형식(PDF, Word, Excel 등)을 확인해주세요.",
      [QuoteErrorType.SUBMISSION_FAILED]:
        "견적 정보가 모두 입력되었는지 확인하고 다시 시도해주세요.",
      [QuoteErrorType.NETWORK_ERROR]:
        "인터넷 연결을 확인하고 다시 시도해주세요.",
      [QuoteErrorType.VALIDATION_ERROR]:
        "입력된 정보가 올바른지 다시 확인해주세요.",
      [QuoteErrorType.UNKNOWN]: "문제가 지속되면 관리자에게 문의해주세요.",
    };

    // Use action if available (includes backend validation details), otherwise fallback
    const description = detail.action || descriptions[detail.type];

    toast.error(detail.message, {
      description,
      duration: 5000,
    });
  },
};
